module.exports = __webpack_public_path__ + "static/media/96.7f56d755.jpg";